module.exports = __webpack_public_path__ + "65cfd86649d5c20a0709e8f51670e3.svg";